module.exports = __webpack_public_path__ + "img/ai9.adb71b37.png";